var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 61,
    viewBox: "0 0 281 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.101562 60.6011L11.9131 0.199394H20.8915L34.0998 29.4988H34.4189L60.0373 0.199394H70.9311L59.1596 60.6011H45.8713L49.7819 40.6039L54.0517 23.2701H53.7325L32.7828 48.185H30.229L20.1333 24.7453H19.6944L17.1804 40.6039L13.4694 60.6011H0.101562Z",
    fill: "url(#paint0_linear_765_2106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 60.86C268.19 60.86 266.536 60.4055 265.105 59.4965C263.673 58.5606 262.553 57.304 261.746 55.7265C260.965 54.1222 260.574 52.3042 260.574 50.2722C260.574 48.2134 260.965 46.3951 261.746 44.8176C262.553 43.2402 263.673 41.9968 265.105 41.0878C266.563 40.1519 268.229 39.6841 270.104 39.6841C271.64 39.6841 272.994 40.0049 274.165 40.6465C275.337 41.2616 276.248 42.144 276.899 43.2936V31.5025H280.804V60.3789H277.29L276.899 57.2506C276.508 57.8656 276.001 58.4538 275.376 59.0151C274.751 59.5499 273.996 59.9911 273.111 60.3388C272.225 60.6862 271.21 60.86 270.065 60.86ZM270.689 57.371C271.913 57.371 272.994 57.0767 273.931 56.4885C274.868 55.9003 275.584 55.0713 276.079 54.0021C276.6 52.9325 276.86 51.6891 276.86 50.2722C276.86 48.855 276.6 47.6252 276.079 46.5822C275.584 45.513 274.868 44.6839 273.931 44.0957C272.994 43.4807 271.913 43.1735 270.689 43.1735C269.518 43.1735 268.463 43.4807 267.526 44.0957C266.588 44.6839 265.86 45.513 265.339 46.5822C264.818 47.6252 264.558 48.855 264.558 50.2722C264.558 51.6891 264.818 52.9325 265.339 54.0021C265.86 55.0713 266.588 55.9003 267.526 56.4885C268.463 57.0767 269.518 57.371 270.689 57.371Z",
    fill: "#D8E267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.619 60.8587C244.083 60.8587 242.742 60.5379 241.597 59.896C240.477 59.2544 239.605 58.292 238.98 57.0085C238.381 55.7249 238.082 54.1073 238.082 52.1556V40.1639H241.987V51.7144C241.987 53.6127 242.391 55.0432 243.198 56.0059C244.005 56.9683 245.164 57.4497 246.674 57.4497C247.689 57.4497 248.601 57.1956 249.408 56.6876C250.241 56.1797 250.892 55.4443 251.36 54.4818C251.829 53.5191 252.063 52.3427 252.063 50.9524V40.1639H255.969V60.3774H252.493L252.22 56.9282C251.621 58.1583 250.749 59.1207 249.603 59.816C248.457 60.5111 247.13 60.8587 245.619 60.8587Z",
    fill: "#D8E267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.998 60.8609C222.149 60.8609 220.483 60.4197 218.999 59.5373C217.541 58.6551 216.382 57.425 215.523 55.8475C214.69 54.2435 214.273 52.3984 214.273 50.313C214.273 48.1739 214.703 46.3157 215.562 44.7383C216.421 43.1339 217.593 41.8909 219.077 41.0084C220.561 40.126 222.228 39.6851 224.076 39.6851C225.951 39.6851 227.617 40.126 229.075 41.0084C230.533 41.8909 231.679 43.1207 232.512 44.6981C233.371 46.2756 233.801 48.1341 233.801 50.2728C233.801 52.412 233.371 54.2701 232.512 55.8475C231.679 57.425 230.52 58.6551 229.036 59.5373C227.552 60.4197 225.873 60.8609 223.998 60.8609ZM223.998 57.4117C225.066 57.4117 226.029 57.1444 226.888 56.6096C227.773 56.0748 228.476 55.2862 228.997 54.2435C229.544 53.174 229.817 51.8503 229.817 50.2728C229.817 48.6954 229.557 47.3853 229.036 46.3426C228.515 45.2731 227.812 44.4709 226.927 43.9361C226.068 43.4013 225.118 43.134 224.076 43.134C223.035 43.134 222.071 43.4013 221.186 43.9361C220.301 44.4709 219.585 45.2731 219.038 46.3426C218.517 47.3853 218.257 48.6954 218.257 50.2728C218.257 51.8503 218.517 53.174 219.038 54.2435C219.585 55.2862 220.288 56.0748 221.147 56.6096C222.032 57.1444 222.983 57.4117 223.998 57.4117Z",
    fill: "#D8E267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.748 60.3789V31.5025H209.654V60.3789H205.748Z",
    fill: "#D8E267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.671 60.8603C186.989 60.8603 184.672 60.2585 182.719 59.0556C180.793 57.8255 179.296 56.1276 178.228 53.9619C177.187 51.7694 176.666 49.2295 176.666 46.342C176.666 43.481 177.187 40.9544 178.228 38.7619C179.296 36.5693 180.793 34.8715 182.719 33.6685C184.672 32.4384 186.989 31.8237 189.671 31.8237C192.874 31.8237 195.464 32.6122 197.443 34.1897C199.448 35.7672 200.724 37.9866 201.27 40.8472H196.974C196.584 39.1895 195.777 37.8661 194.553 36.8769C193.355 35.8876 191.728 35.393 189.671 35.393C187.823 35.393 186.221 35.8342 184.867 36.7163C183.514 37.5988 182.472 38.8554 181.743 40.4863C181.014 42.1175 180.65 44.0692 180.65 46.342C180.65 48.6145 181.014 50.5797 181.743 52.2375C182.472 53.8684 183.514 55.125 184.867 56.0075C186.221 56.8631 187.823 57.2907 189.671 57.2907C191.728 57.2907 193.355 56.8229 194.553 55.8871C195.777 54.9247 196.584 53.6278 196.974 51.9967H201.27C200.724 54.7774 199.448 56.9566 197.443 58.5341C195.464 60.0847 192.874 60.8603 189.671 60.8603Z",
    fill: "#D8E267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.233 60.5953C163.446 60.5953 166.86 57.0884 166.86 52.7625C166.86 48.4365 163.446 44.9296 159.233 44.9296C155.02 44.9296 151.605 48.4365 151.605 52.7625C151.605 57.0884 155.02 60.5953 159.233 60.5953Z",
    fill: "#D8E267"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_765_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.207 0.650642C141.117 0.650674 144.566 1.34916 147.572 2.85166C150.605 4.32686 152.973 6.45775 154.675 9.24419C156.378 12.0033 157.229 15.3363 157.229 19.2428C157.229 23.4771 156.245 27.261 154.276 30.5938C152.334 33.9267 149.647 36.5494 146.216 38.4616C142.784 40.3466 138.833 41.2891 134.364 41.2891H124.978L121.146 60.8568H110.635L110.634 60.8619H83.6811C90.1469 60.6324 95.8115 58.8786 100.675 55.601C105.847 52.0605 109.526 47.1799 111.715 40.9594L111.757 40.7467H97.5695C96.4255 43.4323 94.7365 45.4744 92.5026 46.8733C90.3236 48.2719 87.6265 48.971 84.4121 48.971C80.4895 48.971 77.4385 47.7962 75.2591 45.4463C73.0801 43.0404 71.9902 39.7954 71.9902 35.7112C71.9902 33.5295 72.29 31.0955 72.8893 28.4101C73.543 25.7247 74.5783 23.1508 75.9947 20.6891C77.4111 18.2274 79.291 16.2131 81.6338 14.6466C84.0311 13.0241 87.0002 12.2128 90.5415 12.2128C93.7559 12.2129 96.2624 12.9961 98.0601 14.5626C99.8579 16.0732 100.811 18.2833 100.92 21.1925H115.14C115.195 14.4787 113.233 9.30326 109.256 5.66658C106.501 3.10822 103 1.43647 98.7533 0.650642H137.207Z",
    fill: "url(#paint1_linear_765_2106)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_765_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.686 29.8532C141.995 29.8532 146.298 25.4339 146.298 19.9823C146.298 14.5308 141.995 10.1115 136.686 10.1115C131.378 10.1115 127.074 14.5308 127.074 19.9823C127.074 25.4339 131.378 29.8532 136.686 29.8532Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_765_2106",
    x: 71.9902,
    y: 0.650642,
    width: 85.2383,
    height: 67.7025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.49126
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.74563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_765_2106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_765_2106",
    x: 119.583,
    y: 10.1115,
    width: 34.2071,
    height: 34.7242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.49126
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.74563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_765_2106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_765_2106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_765_2106",
    x1: 35.5162,
    y1: 0.199394,
    x2: 35.5162,
    y2: 60.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDF806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F9204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_765_2106",
    x1: 114.61,
    y1: 0.650642,
    x2: 114.61,
    y2: 60.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDF806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F9204"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_2106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcpLogo);
export default __webpack_public_path__ + "static/media/mcp-logo.08a6a2ed55384dd3111ad58d28142743.svg";
export { ForwardRef as ReactComponent };